import {
    type FC
} from "react";
import {
    View
} from "react-native";
import type IAlertActionsProps from "./type";
import stylesheet, {
    useStyles
} from "./stylesheet";
import {
    NCoreUIKitTheme
} from "../../../../core/hooks";
import {
    usePointerType
} from "../../../../helpers/pointer";
import type {
    AlertPartContentProps
} from "../../type";
import {
    withAlertContext
} from "../../context";

const AlertActionsContent: FC<AlertPartContentProps<IAlertActionsProps>> = ({
    customTheme: customThemeProp,
    children,
    context,
    style,
    ...props
}) => {
    const {
        controlHeights,
        touchTargets,
        typography,
        spaces
    } = NCoreUIKitTheme.useContext(customThemeProp ?? context.customTheme);

    const pointerType = usePointerType();

    const {
        container: containerDynamicStyle
    } = useStyles({
        isCompact: context.isCompact,
        controlHeights,
        touchTargets,
        pointerType,
        typography,
        spaces
    });

    return <View
        {...props}
        style={[
            style,
            stylesheet.container,
            context.isCompact || context.isActionInline ? stylesheet.inline : stylesheet.wrapped,
            containerDynamicStyle
        ]}
    >
        {children}
    </View>;
};
export default withAlertContext("actions", AlertActionsContent);
